import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ShareAndroidIcon } from '@spotahome/ui-library';

import ShareIOsIcon from '../../icons/ShareIOsIcon';

import './ShareButton.scss';

const isAndroid = deviceOS => /(Android)/i.test(deviceOS);

const WEB_DATA_CY = 'booknow_card_share_button';
const ANDROID_DATA_CY = 'booknow_card_android_share_button';

const ShareButton = ({ onClick, className, deviceOS = '', count = null }) => {
  const inAndroid = isAndroid(deviceOS);
  const dataCy = inAndroid ? ANDROID_DATA_CY : WEB_DATA_CY;

  const shareIcon = inAndroid ? <ShareAndroidIcon /> : <ShareIOsIcon />;

  return (
    <button
      className={classnames('share-button', className)}
      onClick={onClick}
      data-cy={dataCy}
      type="button"
    >
      {count ? <span>{count}</span> : null}
      {shareIcon}
    </button>
  );
};

ShareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  deviceOS: PropTypes.string,
  count: PropTypes.number
};

export default ShareButton;
